<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">车辆维修验收验收</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">

          <repair-accept v-if="wxform" ref="create" :useApplyType="useApplyType" :userData="userData"
            :formByFather="form" :wxform="wxform">
          </repair-accept>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments ref="attachments" style="margin-left:-10px;" :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
              <div class="tip">
                <p v-if="useApplyType=='zgs'">* 修车费用金额较大需报集团分管副总同意</p>
                <p v-if="useApplyType=='jt'">* 重要保养和维修项目，需经分管副总审批</p>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <!-- <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom> -->

            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsersData" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div>


          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitCar()" class="form-btn" type="success">确认提交车辆维修验收申请
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import approvalUsers from '@/Mixins/approvalUsers'
  // import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'

  import RepairAccept from '@/page/form/car/accept'
  export default {
    components: {
      ApprovalItem,
      RepairAccept,
      ApprovalItem,
      Attachments,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        formLoading: false,
        wxform: "",
        form: {
          depId: "",

          wxApplyId: "",
          wxh: "",
          wxq: "",

          applyType: "",
          json: true,
        },
        useApplyType: "",
        carType: "",
        approvalUsersData: '',
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1
    },
    mounted() {
      this.calcApplyType()
      if (this.$route.query.wxApplyId) {
        this.form.wxApplyId = this.$route.query.wxApplyId
        this.getWxApplyInfo()
      }
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
        this.formLoading = true
        this.getApplyInfo()
      }
    },
    methods: {
      // 获取维修申请内容
      getWxApplyInfo() {
        ajax.get('/car/apply/info/' + this.form.wxApplyId, '', (res) => {
          this.wxform = res.vo
          this.wxform.carId = this.wxform.car.id
          this.wxform.depId = this.wxform.department.id
        })
      },
      // 获取原审批表内容
      getApplyInfo() {
        ajax.get('/car/apply/info/' + this.form.applyId, '', (res) => {
          this.applyInfo = res.vo

          this.wxform = res.vo.wxApply
          this.wxform.carId = this.wxform.car ? this.wxform.car.id : ''
          this.wxform.depId = this.wxform.department.id

          this.form = this.applyInfo
          this.form.applyId = this.form.flow.applyId
          this.form.json = true

          this.form.applyType = this.form.type

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.setSelectArr(this.applyInfo, this.applyInfo.type)
          this.formLoading = false
        })
      },
      // 提交维修车辆申请单
      SubmitCar() {
        this.form = this.$refs.create.getFromData()

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }
        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        let _url = !this.form.applyId ? '/car/apply' : '/car/apply/edit?applyId=' + this.form.applyId

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.applyId) {
            this.$message.success("提交车辆验收申请成功，请耐心等待领导审批")
          } else {
            this.$message.success("修改车辆验收申请成功，请耐心等待领导审批")
          }
          this.$router.push('/Car/RepairList/2')
        }, (res) => {
          this.formLoading = false
        })
      },
      // 识别审批type
      calcApplyType() {
        this.form.applyType = '88'
        this.approvalUsersData = this.approvalUsers['c' + this.form.applyType]
        this.setSelectArr(this.applyInfo, this.form.applyType)
      },
    },
    watch: {
      // 'useApplyType'() {
      //   this.calcApplyType()
      // },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/car/acceptApply.vue